import React from "react";

export default function Handicapper() {
  return (
    <div>
      <div>
        <h1 className="text-lg font-bold">Handicapper Detail</h1>
      </div>
      <hr className="border-black border-2 mt-2" />
    </div>
  );
}
